import React, { useReducer } from 'react';

import ActionsPanelDispatch from '../../contexts/actionsPanelDispatch';
import actionsPanelReducer from '../../reducers/actionsPanel.reducer';
import PoliciesQuotesDispatch from '../../contexts/policiesQuotes.dispatch';
import policiesQuotesReducer from '../../reducers/policiesQuotes.reducer';

import PolicieQuoteDetailsPanel from './PolicyQuoteDetailsPanel';
import ClientPanel from './ClientPanel';
import PoliciesQuotesPanel from './PoliciesQuotesPanel';
import CommunicationsPanel from './CommunicationsPanel';
import ActionsPanel from './ActionsPanel';
import style from './ClientDetailsPage.module.css';

const ClientDetailsPage = React.memo(({ history, match }) => {
  const { clientId } = match.params;

  if (!clientId) {
    history.push('/');
  }

  const [actionsPanelState, actionsPanelDispatch] = useReducer(
    actionsPanelReducer,
    {
      policies: false,
      proposals: false,
    },
  );

  const [policiesQuotesState, policiesQuotesDispatch] = useReducer(
    policiesQuotesReducer,
    {
      id: null,
      policy: false,
      policies: true,
      quotes: true,
      bindRequestSent: false,
    },
  );

  return (
    <>
      <div className={style.clientDetails}>
        <ClientPanel clientId={clientId} />
        <PoliciesQuotesDispatch.Provider value={policiesQuotesDispatch}>
          {policiesQuotesState.id && (
            <PolicieQuoteDetailsPanel
              id={policiesQuotesState.id}
              clientId={clientId}
              policy={policiesQuotesState.policy}
            />
          )}
          {!policiesQuotesState.id && (
            <CommunicationsPanel clientId={clientId} />
          )}
          <ActionsPanelDispatch.Provider value={actionsPanelDispatch}>
            <PoliciesQuotesPanel
              panelState={policiesQuotesState}
              clientId={clientId}
            />
            <ActionsPanel panelState={actionsPanelState} clientId={clientId} />
          </ActionsPanelDispatch.Provider>
        </PoliciesQuotesDispatch.Provider>
      </div>
    </>
  );
});

ClientDetailsPage.propTypes = {};

export default ClientDetailsPage;
